<app-sidebar-v2 *ngIf="menuVersion === MenuVersionEnum.V2; else legacyMenu"></app-sidebar-v2>
<ng-template #legacyMenu>
  <app-sidebar></app-sidebar>
</ng-template>
